/** Area unit codes accepted by the API and shown in area-type grid dropdowns. */
export const AREA_TYPE_OPTIONS = ["SQM", "SQFT", "HA", "ACRE"] as const;
